import React from 'react';
import Promotions from '../components/Promotions';

export const PromotionsPage = () => {
  return <Promotions />;
};

export default PromotionsPage;
